import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../../../generic-components/Icon';
import Heading from '../../../../../generic-components/Heading';
import BellIcon from '../../../../../assets/svg/bell-icon.svg';
import ToggleButton from '../../../InvoiceOnboarding/components/ToggleButton';
import Button from '../../../../../generic-components/Button';
import { STYLES, TEXTS } from '../../consts/consts';
import { UserMessage } from '../../../../../DesignSystem/LiliUserMessage/UserMessage';
import { IInvoiceReminder } from '../../types/types';
import { RemindersController } from './RemindersController';
import { useGetInvoiceRemindersQuery } from '../../../../../hooks/query/useGetInvoiceRemindersQuery';
import { useStore } from '../../../../../store';

const { INVOICE_CREATION: { INVOICE_REMINDERS: componentTexts } } = TEXTS;

export const Reminders = () => {
  const invoiceData = useStore(state => state.invoiceData);
  const invoiceRemindersData = useStore(state => state.invoiceRemindersData);
  const setInvoiceReminders = useStore(state => state.setInvoiceReminders);
  const { customer: { externalId } } = useStore(state => state.summary);
  const [remindersToggleStatus, setRemindersToggleStatus] = useState<boolean>(false);
  const [isRemindersModalShowing, setIsRemindersModalShowing] = useState<boolean>(false);
  // const [reminders, setReminders] = useState<IInvoiceReminder[]>([]);
  const { t } = useTranslation();

  const { data: initialRemindersData } = useGetInvoiceRemindersQuery({ customerId: externalId });

  const handleToggleReminders = () => {
    setRemindersToggleStatus(!remindersToggleStatus);
  };

  const handleSaveTogglesStatus = (updatedReminders: IInvoiceReminder[], masterStatus: boolean) => {
    setInvoiceReminders(updatedReminders);
    setRemindersToggleStatus(masterStatus);
    // setIsRemindersModalShowing(false);
  };

  const activeRemindersCount = useMemo(() => {
    let counter = 0;
    invoiceRemindersData.forEach((reminder:IInvoiceReminder) => {
      if (reminder.selected) {
        counter++;
      }
    });
    return counter;
  }, [invoiceRemindersData]);

  const dueDate = useMemo(() => {
    const date = invoiceData?.invoicePaymentTerm.dueDate;
    return new Date(date || '');
  }, [invoiceData]);

  useEffect(() => {
    if (!remindersToggleStatus) {
      /** If user switch OFF the MASTER toggle, turn all reminders OFF */
      const updatedReminders = [...invoiceRemindersData]
        .map((r) => {
          r.selected = false;
          return r;
        });
      setInvoiceReminders(updatedReminders);
    } else if (remindersToggleStatus && !activeRemindersCount) {
      const updatedReminders = [...invoiceRemindersData]
        .map((r) => {
          r.selected = true;
          return r;
        });
      setInvoiceReminders(updatedReminders);
    }
  }, [remindersToggleStatus]);

  useEffect(() => {
    setRemindersToggleStatus(activeRemindersCount > 0);
  }, [activeRemindersCount]);

  useEffect(() => {
    if (initialRemindersData?.invoiceReminders) {
      setInvoiceReminders(initialRemindersData.invoiceReminders);
    }
  }, [initialRemindersData?.invoiceReminders]);

  return (
    <div className='basis-1/2'>
      {isRemindersModalShowing
          && (
          <UserMessage
            mainWrapperClassName={STYLES.INVOICE_CREATION.USER_MESSAGE.MAIN_WRAPPER}
            contentWrapperClassName={STYLES.INVOICE_CREATION.USER_MESSAGE.remindersController}
            onClick={() => setIsRemindersModalShowing(false)}
            id='invoicePreviewWrapper'
          >
            <RemindersController
              handleClose={() => setIsRemindersModalShowing(false)}
              onSaveToggles={(updatedReminders, masterStatus) => handleSaveTogglesStatus(updatedReminders, masterStatus)}
              masterToggleStatus={remindersToggleStatus}
              remindersList={invoiceRemindersData}
              dueDate={dueDate}
            />
          </UserMessage>
          )}
      <div className={STYLES.INVOICE_CREATION.INVOICE_REMINDERS.CONTENT_WRAPPER}>
        <div className={STYLES.INVOICE_CREATION.INVOICE_REMINDERS.HEADER_WRAPPER}>
          <Icon src={BellIcon} />
          <Heading title={t(componentTexts.MAIN_TITLE)} className={STYLES.INVOICE_CREATION.INVOICE_REMINDERS.HEADER} />
        </div>
        <Heading
          title={t(componentTexts.REMINDERS_MAIN_DISCLAIMER)}
          className={STYLES.INVOICE_CREATION.INVOICE_REMINDERS.DISCLAIMER}
        />
        <div className={STYLES.INVOICE_CREATION.INVOICE_REMINDERS.ACTIONS_WRAPPER}>
          <div className={STYLES.INVOICE_CREATION.INVOICE_REMINDERS.TOP_ACTIONS}>
            <div className={STYLES.INVOICE_CREATION.INVOICE_REMINDERS.TOP_ACTIONS_COUNTER_TITLE_WRAPPER}>
              <div className={STYLES.INVOICE_CREATION.INVOICE_REMINDERS.COUNTER_WRAPPER}>
                <Heading id='paymentRemindersCounter' title={activeRemindersCount.toString()} className={STYLES.INVOICE_CREATION.INVOICE_REMINDERS.COUNTER_HEADER} />
              </div>
              <Heading title={t(componentTexts.MASTER_TOGGLE_LABEL)} className={STYLES.INVOICE_CREATION.INVOICE_REMINDERS.TOGGLE_HEADER} />
            </div>
            <ToggleButton toggleState={remindersToggleStatus} toggle={handleToggleReminders} buttonId='elTogglePaymentReminders' />
          </div>
          <Button onClick={() => setIsRemindersModalShowing(true)} className='' id='elButtonOpenRemindersModal' childElement={<Heading title={t(componentTexts.REMINDERS_CONTROLLER_TRIGGER)} className={STYLES.INVOICE_CREATION.INVOICE_REMINDERS.BOTTOM_ACTION} />} />
        </div>
      </div>
    </div>
  );
};
